export default __webpack_public_path__ + "static/banner-back-e1b6ccd0c9b96905c9c8c78b0bbe56b2.webp";